module.exports = __webpack_public_path__ + "img/globe.93f7d40f.svg";